(() => {
  const normalize = (value = '') => value.toString().trim().toLocaleLowerCase('es');

  const updateColorImage = (section, selectedOptions) => {
    const optionGroups = [...section.querySelectorAll('[data-designer-option]')];
    const colorGroup = optionGroups.find((group) => {
      const label = normalize(group.querySelector('legend')?.textContent);
      return label.includes('color') || label.includes('colour');
    });

    if (!colorGroup) return;
    const position = Number(colorGroup.dataset.optionPosition) - 1;
    const selectedColor = normalize(selectedOptions[position]);
    const images = [...section.querySelectorAll('.ko-designer-product__image')];
    if (images.length < 2) return;

    let selectedIndex = 0;
    if (selectedColor.includes('blanco') || selectedColor.includes('white')) selectedIndex = 1;
    if (selectedColor.includes('negro') || selectedColor.includes('black')) selectedIndex = 0;

    images.forEach((image, index) => image.classList.toggle('is-selected', index === selectedIndex));
  };

  const formatMoney = (cents) => {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.KODesignerMoneyFormat || '${{amount_no_decimals_with_comma_separator}}');
    }

    return new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: 'CLP',
      maximumFractionDigits: 0
    }).format(cents / 100);
  };

  const selectedOptionsFor = (section) => {
    return [...section.querySelectorAll('[data-designer-option]')]
      .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
      .map((group) => group.querySelector('[aria-pressed="true"]')?.dataset.optionValue || '');
  };

  const syncProduct = (section) => {
    const variantsElement = section.querySelector('[data-designer-variants]');
    if (!variantsElement) return;

    let variants = [];
    try {
      variants = JSON.parse(variantsElement.textContent);
    } catch (_error) {
      return;
    }

    const selectedOptions = selectedOptionsFor(section);
    const selectedVariant = variants.find((variant) => {
      return variant.options.every((option, index) => option === selectedOptions[index]);
    });

    const variantInput = section.querySelector('[data-designer-variant-id]');
    const price = section.querySelector('[data-designer-price]');
    const submit = section.querySelector('[data-designer-submit]');

    if (selectedVariant) {
      if (variantInput) variantInput.value = selectedVariant.id;
      if (price) price.textContent = formatMoney(selectedVariant.price);
      if (submit) {
        submit.disabled = !selectedVariant.available;
        const label = submit.querySelector('span') || submit;
        label.textContent = selectedVariant.available ? 'COMPRAR' : 'SOLD OUT';
      }
    } else if (submit) {
      submit.disabled = true;
      const label = submit.querySelector('span') || submit;
      label.textContent = 'NO DISPONIBLE';
    }

    section.querySelectorAll('[data-designer-option]').forEach((group) => {
      const groupPosition = Number(group.dataset.optionPosition) - 1;
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        const candidate = [...selectedOptions];
        candidate[groupPosition] = button.dataset.optionValue;
        const possible = variants.some((variant) => {
          return variant.available && variant.options.every((option, index) => option === candidate[index]);
        });
        button.disabled = !possible && button.getAttribute('aria-pressed') !== 'true';
      });
    });

    updateColorImage(section, selectedOptions);
  };

  document.addEventListener('click', (event) => {
    const soldCard = event.target.closest('.ko-designer-card--sold');
    if (soldCard) {
      const active = !soldCard.classList.contains('is-active');
      soldCard.classList.toggle('is-active', active);
      soldCard.setAttribute('aria-pressed', String(active));
      return;
    }

    const optionButton = event.target.closest('[data-designer-option] [data-option-value]');
    if (!optionButton) return;
    const group = optionButton.closest('[data-designer-option]');
    const section = optionButton.closest('[data-ko-designer-product]');
    if (!group || !section) return;

    group.querySelectorAll('[data-option-value]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button === optionButton));
    });
    syncProduct(section);
  });

  const initialize = (root = document) => {
    root.querySelectorAll('[data-ko-designer-product]').forEach(syncProduct);
  };

  document.addEventListener('DOMContentLoaded', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
